import isNil from 'lodash.isnil';

export function callAll(...funcs) {
  return (...args) =>
    funcs.map(func => {
      if (typeof func !== 'function') return undefined;
      return func(...args);
    });
}

export function deprecateFn() {
  let isAlreadyCalled = false;

  /* eslint-disable-next-line */
  return function(thingToDeprecate, message) {
    if (isAlreadyCalled) return;

    if (!isNil(thingToDeprecate)) {
      try {
        throw new Error(message);
      } catch (error) {
        isAlreadyCalled = true;
        /* eslint-disable-next-line no-console */
        console.warn(`[Deprecation] ${error.message}`);
      }
    }
  };
}
